import React from 'react'
import { Box } from '../Core'

const IconCircle = ({ src, alt, ...rest }) => (
    <Box
        borderRadius="2rem"
        css={`
            overflow: hidden;
        `}
        {...rest}
    >
        <img src={src} alt={alt} className="img-fluid w-100" />
    </Box>
)

export default IconCircle
